import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import mapPageReducer from './MapPage';
import directionsPageReducer from './DirectionsPage';
import locationDetailPageReducer from './LocationDetailPage';
import streetViewPageReducer from './StreetViewPage';

const rootReducer = history => {
	return combineReducers({
		router: connectRouter(history),
		mapPageReducer,
		streetViewPageReducer,
		locationDetailPage: combineReducers({
			locationDetailPageReducer,
			directionsPageReducer
		})
	});
};

export default rootReducer;